import {
  getOrders, createOrder, createOrderNoActive, patchOrder,
  getBill, getInvoice, getBillOfLading,
  patchMakeCancelled, patchRequestBill, patchRequestInvoice,
  patchUploadOrderFile, patchMakeInvoiced, patchRequestAddPay,
  patchRequestSetDefPayment, patchMakeAwaitReceipt,
  patchMakeReceived
} from "../../utils/api";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { SET_PORTAL_API, RESET_PORTAL } from "./portal_actions";
import {
  TITLE_ERROR, TITLE_NOTIFICATION,
  TEXT_BILL_REQUESTED, TEXT_INVOICE_REQUESTED,
  TEXT_FILE_UPLOADED, TEXT_BILL_CONFIRMED,
  TEXT_ENTRANCE_CONFIRMED, TEXT_SET_DEF_PAYMENT_CONFIRMED,
  TEXT_EDIT_ORDER_CONFIRMED, TEXT_AWAIT_RECEIPT_CONFIRMED,
  TEXT_RECEIVED_CONFIRMED
} from "../../utils/constants";
import { getCookie } from "../../utils/cookie";
import { clearCartThunk, CLEAR_CART, removeActiveFromCartThunk } from "../actions/cart_actions";
import { CURR_ORDER_SET, REQUEST_GET_ORDER_SUCCESS } from "./curr_order_actions";
import { SET_CUSTOMER } from "./customer_actions";
import { REQUEST_GET_ME_SUCCESS, LOGOUT } from "./user_actions";
import { NEW_ORDER_RESET_PRODUCTS } from "./new_order_actions";
import { RESET_CUSTOMER } from "./customer_actions";
import { getProductsThunk } from "./products_actions";

export const REQUEST_GET_ORDERS = 'REQUEST_GET_ORDERS';
export const REQUEST_GET_ORDERS_SUCCESS = 'REQUEST_GET_ORDERS_SUCCESS';
export const REQUEST_GET_ORDERS_FAILED = 'REQUEST_GET_ORDERS_FAILED';

export const REQUEST_POST_ORDERS = 'REQUEST_POST_ORDERS';
export const REQUEST_POST_ORDERS_SUCCESS = 'REQUEST_POST_ORDERS_SUCCESS';
export const REQUEST_POST_ORDERS_FAILED = 'REQUEST_POST_ORDERS_FAILED';

export const REQUEST_PATCH_ORDER = 'REQUEST_PATCH_ORDER';
export const REQUEST_PATCH_ORDER_SUCCESS = 'REQUEST_PATCH_ORDER_SUCCESS';
export const REQUEST_PATCH_ORDER_FAILED = 'REQUEST_PATCH_ORDER_FAILED';
export const CLEAR_ORDERS = 'CLEAR_ORDERS';



export const getOrdersThunk = (accessToken, refreshToken, page = 1, user_id, status, year, firm_id, payment_status) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_GET_ORDERS });
    getOrders(accessToken, refreshToken, page, user_id, status, year, firm_id, payment_status)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDERS_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_GET_ORDERS_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const patchOrderThunk = (accessToken, refreshToken, id, data) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_PATCH_ORDER });
    patchOrder(accessToken, refreshToken, id, data)
      .then(data => {
        dispatch({ type: SET_CUSTOMER, customer: data.customer });
        dispatch({
          type: CURR_ORDER_SET,
          payload: data
        });
        dispatch({ type: RESET_PORTAL });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_EDIT_ORDER_CONFIRMED
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_PATCH_ORDER_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}


// переписать фунцию
export const patchMakeCancelledOrderThunk = (accessToken, refreshToken, id) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_PATCH_ORDER });
    patchMakeCancelled(accessToken, refreshToken, id)
      .then(res => {
        // dispatch({
        //   type: REQUEST_PATCH_ORDER_SUCCESS,
        //   payload: res
        // });
        dispatch({
          type: CURR_ORDER_SET,
          payload: res
        });
        dispatch({ type: RESET_PORTAL });
      })
      .catch(error => {
        dispatch({ type: REQUEST_PATCH_ORDER_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const patchMakeInvoicedThunk = (accessToken, refreshToken, id) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_PATCH_ORDER });
    patchMakeInvoiced(accessToken, refreshToken, id)
      .then(res => {
        // dispatch({
        //   type: REQUEST_PATCH_ORDER_SUCCESS,
        //   payload: res
        // });
        dispatch({
          type: CURR_ORDER_SET,
          payload: res
        });
        dispatch({ type: RESET_PORTAL });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_BILL_CONFIRMED
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_PATCH_ORDER_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}


export const createOrderNoActiveThunk = (navigate, data) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_POST_ORDERS });
    createOrderNoActive(data)
      .then(data => {

        // dispatch({
        //   type: REQUEST_POST_ORDERS_SUCCESS,
        //   payload: data
        // });

        // dispatch({
        //   type: REQUEST_GET_ME_SUCCESS,
        //   id: data.customer.id,
        //   first_name: data.customer.first_name,
        //   last_name: data.customer.last_name,
        //   surname: data.customer.surname,
        //   email: data.customer.email,
        //   phone: data.customer.phone,
        //   is_active: data.customer.is_active,
        //   discount_level: data.customer.discount_level,
        //   role: data.customer.role,
        //   perm_news: data.customer.perm_news,
        //   perm_system_messages: data.customer.perm_system_messages,
        //   last_ship_name: data.customer.last_ship_name,
        //   last_ship_description: data.customer.last_ship_description,
        //   pre_last_ship_name: data.customer.pre_last_ship_name,
        //   pre_last_ship_description: data.customer.pre_last_ship_description
        // });
        // dispatch({ type: SET_CUSTOMER, customer: data.customer });

        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: 'Заказ создан, в ближайшее время менеджер свяжется с Вами.',
        });
        dispatch({ type: LOGOUT });
        dispatch({ type: CLEAR_ORDERS });
        dispatch({ type: RESET_CUSTOMER });
        dispatch({ type: CLEAR_CART });
        dispatch(getProductsThunk('', ''));
        navigate('/', { replace: true });
      })
      .catch(error => {
        dispatch({ type: REQUEST_POST_ORDERS_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      })
  }
}

export const createOrderThunk = (accessToken, refreshToken, navigate, data_d) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_POST_ORDERS });
    createOrder(accessToken, refreshToken, data_d)
      .then(data => {
        dispatch({
          type: REQUEST_POST_ORDERS_SUCCESS,
          payload: data
        });
        dispatch({ type: SET_CUSTOMER, customer: data.customer });
        // тут заменим clearCartThunk на removeActiveFromCartThunk
        // dispatch(clearCartThunk(accessToken, refreshToken));
        dispatch(removeActiveFromCartThunk(accessToken, refreshToken, data_d.products_in_cart));
        navigate('/orders', { replace: true });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: 'Заказ создан, в ближайшее время менеджер свяжется с Вами.',
        });
        dispatch({
          type: NEW_ORDER_RESET_PRODUCTS
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_POST_ORDERS_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const getBillThunk = (id, name) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    try {
      await getBill(getCookie("accessToken"), getCookie("refreshToken"), id, name);
    } catch (error) {
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_ERROR,
        text: error.message || "Ошибка скачивания файла.",
      });
    } finally {
      dispatch({ type: END_LOADING });
    }
  };
};

export const getInvoiceThunk = (id, name) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    try {
      await getInvoice(getCookie("accessToken"), getCookie("refreshToken"), id, name);
    } catch (error) {
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_ERROR,
        text: error.message || "Ошибка скачивания файла.",
      });
    } finally {
      dispatch({ type: END_LOADING });
    }
  };
};


export const getBillOfLadingThunk = (id, name) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    try {
      await getBillOfLading(getCookie("accessToken"), getCookie("refreshToken"), id, name);
    } catch (error) {
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_ERROR,
        text: error.message || "Ошибка скачивания файла.",
      });
    } finally {
      dispatch({ type: END_LOADING });
    }
  };
};

export const patchRequestBillThunk = (id) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    patchRequestBill(getCookie("accessToken"), getCookie("refreshToken"), id)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: data
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_BILL_REQUESTED
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const patchUploadOrderFileThunk = (id, formData, docType) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    patchUploadOrderFile(getCookie("accessToken"), getCookie("refreshToken"), id, formData, docType)
      .then(res => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: res
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_FILE_UPLOADED
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const patchRequestInvoiceThunk = (id) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    patchRequestInvoice(getCookie("accessToken"), getCookie("refreshToken"), id)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: data
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_INVOICE_REQUESTED
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}


export const patchRequestAddPayThunk = (id, data) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    patchRequestAddPay(getCookie("accessToken"), getCookie("refreshToken"), id, data)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: data
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_ENTRANCE_CONFIRMED
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}


export const patchSetDefPaymentThunk = (id, data) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    patchRequestSetDefPayment(getCookie("accessToken"), getCookie("refreshToken"), id, data)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: data
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_SET_DEF_PAYMENT_CONFIRMED
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}


export const patchMakeAwaitReceiptOrderThunk = (accessToken, refreshToken, id) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    patchMakeAwaitReceipt(accessToken, refreshToken, id)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: data
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_AWAIT_RECEIPT_CONFIRMED
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}


export const patchMakeReceivedOrderThunk = (accessToken, refreshToken, id) => {
  return async function (dispatch) {
    dispatch({ type: START_LOADING });
    patchMakeReceived(accessToken, refreshToken, id)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: data
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_RECEIVED_CONFIRMED
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
